export interface NavigationSearchProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'className'> {
  data: any
  onSearch: (value: string) => void
  onClose: () => void
  keywords?: {
    search_term: string
    search_date: string
    shopify_domain: string
    counts: number
  }[]
  searchResult: any
  isSearching?: boolean
  className?: string
}

export enum SearchStatus {
  Default = 'default',
  Predict = 'predict',
  Empty = 'empty',
}
